import { memo, useMemo } from 'react';

import {
  WorkspaceAgentActionsMenuListRowSkeleton,
  type WorkspaceAgentActionsMenuListRowSkeletonLayout,
} from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/actions-menu/WorkspaceAgentActionsMenuListRowSkeleton';

export type WorkspaceAgentActionsMenuListRowSkeletonListProps = {
  'data-testid': string;
  layout: WorkspaceAgentActionsMenuListRowSkeletonLayout;
  loadingLabel: string;
  rowCount: number;
};

export const WorkspaceAgentActionsMenuListRowSkeletonList = memo(
  ({
    'data-testid': dataTestId,
    layout,
    loadingLabel,
    rowCount,
  }: WorkspaceAgentActionsMenuListRowSkeletonListProps) => {
    const rowKeys = useMemo(
      () => Array.from({ length: rowCount }, (_, index) => `workspace-agent-actions-menu-skeleton-${index}`),
      [rowCount],
    );

    return (
      <div aria-busy="true" aria-live="polite" className="flex w-full flex-col" data-testid={dataTestId}>
        <span className="sr-only">{loadingLabel}</span>
        {rowKeys.map((rowKey) => (
          <WorkspaceAgentActionsMenuListRowSkeleton key={rowKey} layout={layout} />
        ))}
      </div>
    );
  },
);

WorkspaceAgentActionsMenuListRowSkeletonList.displayName = 'WorkspaceAgentActionsMenuListRowSkeletonList';
